/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Header.css'); }
var Logo_1 = require("./Logo");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var propertyToMCSSstate_1 = require("./util/propertyToMCSSstate");
var singleClassComponent_1 = require("./util/singleClassComponent");
var throttle_1 = require("./util/throttle");
var warning = require("fbjs/lib/warning");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-header");
var Header = /** @class */ (function (_super) {
    tslib_1.__extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hidden: false
        };
        _this.updateSpacing = throttle_1.throttle(_this.updateSpacing.bind(_this), 100, true);
        _this.addEventListeners = _this.addEventListeners.bind(_this);
        _this.removeEventListeners = _this.removeEventListeners.bind(_this);
        return _this;
    }
    Header.prototype.componentWillUpdate = function (nextProps, nextState) {
        if (nextProps.positioning === "hideable") {
            var scrollContext = this.context.scrollContext;
            if (scrollContext) {
                var didScrollUp = scrollContext.didScrollUp, didScrollDown = scrollContext.didScrollDown;
                if (didScrollUp && this.state.hidden) {
                    this.setState({ hidden: false });
                }
                else if (didScrollDown && !this.state.hidden) {
                    this.setState({ hidden: true });
                }
            }
            else {
                warning(false, "To assign the hideable positioning to a Header element, it must be a child or descendant of a ScrollPositionProvider element");
            }
        }
        return null;
    };
    Header.prototype.componentDidUpdate = function () {
        this.updateSpacing();
    };
    Header.prototype.componentDidMount = function () {
        this.addEventListeners();
    };
    Header.prototype.componentWillUnmount = function () {
        this.removeEventListeners();
    };
    Header.prototype.addEventListeners = function () {
        window.addEventListener("resize", this.updateSpacing);
    };
    Header.prototype.removeEventListeners = function () {
        window.removeEventListener("resize", this.updateSpacing);
    };
    Header.prototype.updateSpacing = function () {
        if (this.beforeContentNode && this.baseNode) {
            this.baseNode.style.marginBottom = this.beforeContentNode.clientHeight + "px";
        }
        else if (this.baseNode && this.baseNode.style.marginBottom) {
            this.baseNode.style.removeProperty("marginBottom");
        }
    };
    Header.prototype.render = function () {
        var _this = this;
        var _a = this.props, beforeContent = _a.beforeContent, children = _a.children, _b = _a.logoVariant, logoVariant = _b === void 0 ? "makro" : _b, _c = _a.positioning, positioning = _c === void 0 ? "fixed" : _c, logoLink = _a.logoLink;
        var _d = this.state.hidden, hidden = _d === void 0 ? false : _d;
        var logo = React.createElement(Logo_1.Logo, { size: "small", variant: logoVariant });
        return (React.createElement("header", { ref: function (ref) { return (_this.baseNode = ref); }, className: classnames(moduleClassName(), propertyToMCSSstate_1.propertyToMCSSstate(moduleClassName(), positioning), hidden && propertyToMCSSstate_1.propertyToMCSSstate(moduleClassName(), "hidden")) },
            React.createElement("div", { className: moduleClassName("position") },
                !!beforeContent && (React.createElement("div", { className: moduleClassName("beforeContent"), ref: function (ref) { return (_this.beforeContentNode = ref); } }, beforeContent)),
                React.createElement("div", { className: moduleClassName("inner") },
                    !!logoLink ? (React.createElement("a", tslib_1.__assign({}, logoLink, { className: moduleClassName("logo") }), logo)) : (React.createElement("div", { className: moduleClassName("logo") }, logo)),
                    React.createElement("div", { className: moduleClassName("content") }, children)))));
    };
    Header.contextTypes = {
        scrollContext: PropTypes.object
    };
    Header.propTypes = {
        logoVariant: PropTypes.oneOf(Object.keys(Logo_1.logoVariantMap)),
        beforeContent: PropTypes.node,
        positioning: PropTypes.oneOf(["fixed", "absolute", "relative", "hideable"]),
        logoLink: PropTypes.shape({
            href: PropTypes.string,
            target: PropTypes.string,
            rel: PropTypes.string
        })
    };
    Header.defaultProps = {
        logoVariant: "makro",
        positioning: "fixed"
    };
    return Header;
}(React.Component));
exports.Header = Header;
exports.HeaderButtons = singleClassComponent_1.singleClassComponent("Header.Buttons", moduleClassName("buttons"), "nav");